var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "es_time",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00889 19.5239C13.8646 19.5239 17.885 15.5036 17.885 10.6478C17.885 8.62023 17.1802 6.7406 16.0053 5.23515L16.684 4.54769C16.8842 4.34753 16.9973 4.07778 16.9973 3.84282C16.9973 3.3555 16.6058 2.96392 16.1011 2.96392C15.8052 2.96392 15.5963 3.05093 15.3875 3.25108L14.7261 3.90373C13.3947 2.77246 11.7413 2.01539 9.93131 1.82395V0.971142C9.93131 0.449017 9.52232 0.013916 9.0002 0.013916C8.49548 0.013916 8.06908 0.449017 8.06908 0.971142V1.82395C3.63974 2.30255 0.132812 6.11404 0.132812 10.6478C0.132812 15.5036 4.16187 19.5239 9.00889 19.5239Z",
    fill: "url(#paint0_linear_1951_26397)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00845 12.0575C8.22527 12.0575 7.60742 11.431 7.60742 10.6565C7.60742 10.1083 7.92069 9.63837 8.39931 9.38602V5.06981C8.39931 4.73043 8.66037 4.46936 8.99975 4.46936C9.33913 4.46936 9.6089 4.73043 9.6089 5.06981V9.39471C10.0962 9.62968 10.4095 10.1083 10.4095 10.6565C10.4095 11.431 9.78293 12.0575 9.00845 12.0575Z",
    fill: "url(#paint1_linear_1951_26397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1951_26397",
    x1: 0.132812,
    y1: 0.013916,
    x2: 0.132812,
    y2: 19.5239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1951_26397",
    x1: 7.60742,
    y1: 4.46936,
    x2: 7.60742,
    y2: 12.0575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsTime);
export default __webpack_public_path__ + "static/media/es_time.f757ebef.svg";
export { ForwardRef as ReactComponent };